import { useTranslation } from 'libs/i18n'
import { useLocation, useNavigate } from 'libs/router'
import { PageTabs } from 'shared/components'
import { useBookingEngineTabs } from './hooks/useBookingEngineTabs'

export const BookingEngineTabs = () => {
	const { t } = useTranslation()
	const { pathname } = useLocation()
	const navigate = useNavigate()
	const tabs = useBookingEngineTabs()

	return (
		<PageTabs
			tabs={tabs}
			activeTab={pathname}
			label={t('Booking engine')}
			onChange={(path) => navigate(path)}
		/>
	)
}
